/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Filter for specific paylines. */
@cc._decorator.ccclass
export default class PaylineFilter extends StreakTrackerFilterBase
{
    /** Valid paylines to not filter. */
    @property({ type: [cc.Integer], visible: true })
    private _validPaylines: number[] = [];
    /** Public getter for valid paylines. */
    public get ValidPaylines(): number[] { return this._validPaylines; }

    /** Filters out symbols outside of valid paylines. */
    public Filter: (symbols: ISymbolData[]) => ISymbolData[]
            = (symbols: ISymbolData[]) => symbols.filter(x => this._validPaylines.filter(y => -1 !== x.Payline.indexOf(y)))
}
